import { useNavigate, useLocation } from '@/lib/router-compat';
import { useCountry } from '@/hooks/useCountry';
import { COUNTRY_CONFIGS, CountryCode } from '@/utils/countryConfig';
import { setCountryCookie } from '@/utils/countryCookie';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { Globe } from '@phosphor-icons/react';

export const CountrySelector = () => {
  const { country, config } = useCountry();
  const navigate = useNavigate();
  const location = useLocation();

  const handleCountryChange = (newCountry: CountryCode) => {
    // Set cookie to remember user's preference
    setCountryCookie(newCountry);
    
    // Get current path without country prefix
    const currentPath = location.pathname.replace(/^\/(uk|de)/i, '') || '/';
    
    // Build new path with new country prefix
    const newCountryPrefix = COUNTRY_CONFIGS[newCountry].path;
    const newPath = newCountryPrefix === '/' 
      ? currentPath 
      : `${newCountryPrefix}${currentPath}`;
    
    navigate(newPath);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="gap-2">
          <Globe className="h-4 w-4" />
          <span className="hidden sm:inline">{config.flag} {config.code}, {config.currency}</span>
          <span className="sm:hidden">{config.flag}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        {Object.values(COUNTRY_CONFIGS).map((countryConfig) => (
          <DropdownMenuItem
            key={countryConfig.code}
            onClick={() => handleCountryChange(countryConfig.code)}
            className={country === countryConfig.code ? 'bg-accent' : ''}
          >
            <span className="mr-2">{countryConfig.flag}</span>
            <span>{countryConfig.name}</span>
            {country === countryConfig.code && (
              <span className="ml-auto text-xs text-primary">✓</span>
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
